import * as service from './compliance.service.js'
import { stringify } from 'querystring';
export default {
  data() {
    return {
      disableChildMeasure: true, //<!--FG - FOOF - 20200908-DG-007 - added disableChildMeasure
      compliance_columns: ['DueDate', 'ResponsibleUserNameAndMahcCodeTitle', 'ResponsibleUserName', 'MahcCodeTitle', 'Actions'],
      optionstable: {
        skin: this.$hydrowareCommonJS.hydrowareTableSkin,
        headings: {
          DueDate: 'Due Date',
          ResponsibleUserNameAndMahcCodeTitle:'Responsibility/Compliance Requirement Measure',
          ResponsibleUserName: 'Responsibility',
          MahcCodeTitle: 'Compliance Requirement Measure', 
          Actions: ''
        },
        columnsClasses: {
            "Actions":"hydroware-2-button-column",
            "DueDate":"hydroware-date-column",
            "ResponsibleUserNameAndMahcCodeTitle":"hidden-md hidden-lg hidden-xl hydroware-label-in-column",
            "ResponsibleUserName":"hidden-xs hidden-sm",
            "MahcCodeTitle":"hidden-xs hidden-sm"
          },
        orderBy:  ["DueDate"],
        labelPosition: 'top',
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100],
        sortable: ["DueDate"],
        texts: {
          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',
        }
      },

      addCompliance: {
        ComplianceDocumentDetailId: '',
        DueDate: '',
        LocationId: '',
        MahcCodeChildId: '',
        MahcCodeId: '',
        Notes: '',
        Responsibility: '',
        LocationId: '',
        Id: ''

      },
      addComplianceCopy: {},
      rules: {
        DueDate: [{
          type: 'date',
          required: true,
          trigger: 'blur',
          message: 'This field is required'
        }],

      },
      complianceMeasures: [],
      MahcCodes: [],
      MahcChildes: [],
      AllUsers: [],
      RefDocuments: [],

      modalTitle: '',
      locationName: '',
      locationId: 25,
      isediting: false,
      isaddding: false
    }
  },

  mounted() {
    let context = this
    this.$router.app.$on('emittedlocation_obj', (data) => {
      context.locationId = data.LocationId ? data.LocationId : ''
      context.locationName = data.LocationName ? ' - ' + data.LocationName : ''
      if (context.locationId) {
        context.GetAllCompliance(context.locationId)
        context.GetComplianceDocuments(context.locationId)
      }
    })

    // this.GetAllCompliance(this.locationId)
    this.GetAllParentMahcCodes()
    // this.GetComplianceDocuments(this.locationId)
    this.GetAllUsers()

  },
 
  //FG - FOOF - TOOLTIPSTER REINITIALIZE ON RESIZE
  created() {
    this.$hydrowareCommonJS.handleTooltips("create");
  },

  destroyed() {
    this.$hydrowareCommonJS.handleTooltips("destroy");
  },





  methods: {
    addCompliancevit() {
      this.isaddding = true
      this.GetChildsByMahcId(this.MahcCodes[0].Id)
      this.addCompliance = {
        ComplianceDocumentDetailId: '',
        DueDate: '',
        LocationId: '', 
        MahcCodeChildId: this.MahcChildes[0].Id,
        MahcCodeId: this.MahcCodes[0].Id,
        Notes: '',
        Responsibility: this.AllUsers[0].Id,
        LocationId: '',
        Id: ''
      }
    },
    showCompliancevit() {
      this.isaddding = false
      this.isediting = false
    },
    ShowAddKudos() {
      let context = this

      setTimeout(function () {
        context.$refs['addKudos'].resetFields()
      }, 10)
      this.isediting = false
      $('#Addkudosmodel').modal('show')
      this.modalTitle = 'Create Kudos'
      this.addKudos = deepcopy(this.kudoBackup)
    },

    GetAllCompliance(locationId) {
      let context = this
      loader.startLoader()
      service.GetAllCompliance(locationId).then(function (response) {

      //FG - FOOF - After Cert - First Release Security (7) Can the user at least view the data ?
      if(context.$hydrowareSecurityJS.isDataRestricted(response)) {
        context.complianceMeasures = []
        return;
      }
      //FG - FOOF - After Cert - First Release Security (7) - above

        if (response && response != null) {
          context.complianceMeasures = response
          tooltip.startTooltip(50)
        } else {

          context.complianceMeasures = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetAllParentMahcCodes() {
      let context = this
      loader.startLoader()
      service.GetAllParentMahcCodes().then(function (response) {

        if (response && response != null) {
          context.MahcCodes = response
          context.addCompliance.MahcCodeId = response[0].Id
          context.GetChildsByMahcId(response[0].Id)
        } else {

          context.MahcCodes = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetChildsByMahcId(id,childId) {//FG - FOOF - 20200908-DG-007 - ADDED childId AS A PARM..IF NOT NULL CHOOSE IT
      let context = this
      loader.startLoader()
      service.GetChildsByMahcId(id).then(function (response) {
        context.disableChildMeasure=true;//FG - FOOF - 20200908-DG-007 - disable the dropdown while its populated and child is chosen
        if (response && response != null) {
          context.MahcChildes = response 
          //FG - FOOF - 20200908-DG-007 - added the if portion of the condition below
          //Prior to this change the child was always set to the first choice in the list
          if(childId != null) 
            context.addCompliance.MahcCodeChildId = childId
          else 
            context.addCompliance.MahcCodeChildId = response[0].Id
        } else {
          context.addCompliance.MahcCodeChildId = ""
          context.MahcChildes = []
        }
        context.disableChildMeasure=false; //FG - FOOF - 20200908-DG-007 - enable the dropdown after its populated and child has been chosen
        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetComplianceDocuments(id) {
      let context = this
      loader.startLoader()
      service.GetAllComplianceDocuments(id).then(function (response) {

        if (response && response != null) {
          context.RefDocuments = response
          context.addCompliance.ComplianceDocumentDetailId = response[0].ComplianceDocumentDetailsId
        } else {

          context.RefDocuments = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetAllUsers() {
      let context = this
      loader.startLoader()
      service.GetAllUsers().then(function (response) {

        if (response && response != null) {
          context.AllUsers = response
          context.addCompliance.Responsibility = response[0].Id

        } else {

          context.AllUsers = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },


    del: function (data) {
      var ID = data.row.Id

      let context = this
      context.$confirm('Are you sure you want to delete?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()
        service.DeleteCompliance(ID).then(function (response) {

          context.GetAllCompliance(context.locationId)
          loader.stopLoader()

          context.$notify({
            title: 'Success',
            message: 'Deleted Successfully',
            type: 'success'
          })

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }).catch(() => {

      })
    },

    cancelpopup: function () {

      $('#Addkudosmodel').modal('hide')
    },

    editcol: function (data) {

      var ID = data.row.Id
      let context = this
      context.EditableColID = ID
      context.addCompliance.MahcCodeId = data.row.MahcCodeParentId

      //FG - FOOF - 20200908-DG-007 - BELOW
      //  DUE TO THE LAG ON DOREEN'S PC WE FOUND THAT THE CHILD CHOICE WOULD REMAIN AS THE FIRST CHOICE
      //  IN THE LIST SOMETIMES SO INSTEAD OF SETTING IT AFTER A TIMEOUT (SEE MORE COMMENTS FOR THIS FIX
      //  A BIT DOWN FURTHER IN THE CODE) I NOW SET THE SELECTED CHILD TO AN EMPTY STRING (THIS FORCES IT
      //  TO BE THE PLACEHOLDER - 'Select'.  I ADDED A PARM TO THE GetChildsByMahcId FUNCTION.  THAT PARM
      //  IS THE CHILD ID.  THAT METHOD NOW GETS THE LIST OF CHILD MEASURES FOR THE PARENT AND THEN SETS
      //  THE SELECTED CHILD TO THE CHILD ID IT WAS PASSED)
      //context.GetChildsByMahcId(context.addCompliance.MahcCodeId)
      context.addCompliance.MahcCodeChildId = ""
      context.GetChildsByMahcId(context.addCompliance.MahcCodeId, data.row.MahcCodeChildId)
      //FG - FOOF - 20200908-DG-007 - ABOVE

      context.addCompliance.ComplianceDocumentDetailId = data.row.ComplianceDocumentDetailId
      context.addCompliance.Responsibility = data.row.Responsibility
      context.addCompliance.Notes = data.row.Notes
      context.addCompliance.LocationId = data.row.LocationId
      context.addCompliance.DueDate = new Date(data.row.DueDate)
      context.addCompliance.Id = data.row.Id

      //FG - FOOF - 20200908-DG-007 - BELOW
      //  SEE COMMENTS FOR 20200908-DG-007 A BIT UP IN THIS CODE
      //setTimeout(function () {
      //  context.addCompliance.MahcCodeChildId = data.row.MahcCodeChildId
      //}, 200)
      //FG - FOOF - 20200908-DG-007 - ABOVE

      context.isediting = true


    },





    AddCompliance(formName) {


      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()

          context.addCompliance['LocationId'] = context.locationId
          context.addCompliance['DueDate'] = context.$options.filters.fdate(context.addCompliance.DueDate)


          service.AddCompliance(context.addCompliance).then(function (response) {

            loader.stopLoader()

            context.$notify({
              title: 'Success',
              message: 'Successfully Created Compliance',
              type: 'success'
            })
            context.GetAllCompliance(context.locationId)
            context.isediting = false
            context.isaddding = false



            /*    if (context.personnelID) {
             context.GetKudos(context.personnelID)
             }*/

          }, (error) => {

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'COMPLIANCE - 1 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },


    UpdateCompliance(formName) {


      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()

          context.addCompliance['LocationId'] = context.locationId

          context.addCompliance['DueDate'] = context.$options.filters.fdate(context.addCompliance.DueDate)

          context.addCompliance['Id'] =
            service.UpdateCompliance(context.addCompliance).then(function (response) {

              loader.stopLoader()

              context.$notify({
                title: 'Success',
                message: ' Compliance Updated successfully',
                type: 'success'
              })
              context.GetAllCompliance(context.locationId)
              context.isediting = false
              context.isaddding = false


              /*    if (context.personnelID) {
               context.GetKudos(context.personnelID)
               }*/

            }, (error) => {

              loader.stopLoader()

              context.$notify({
                title: 'Error',
                message: error.responseJSON.Message,
                type: 'error'
              })
            })
        } else {
          this.$notify({

            title: 'Error',

            message: 'COMPLIANCE -2 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },


    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
  watch: {

    isediting: function (val) {
      this.$router.app.$emit('sidebar_hide', val)
    },
    isaddding: function (val) {

      this.$router.app.$emit('sidebar_hide', val)
    }


  },
}



// WEBPACK FOOTER //
// ./src/pages/Compliance/compliance_management.controller.js